import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator, errorMessageGenerator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/departmetns/settings/depatment-courses/get/REQUEST';
export const SUCCESS = '@app/departmetns/settings/depatment-courses/get/SUCCESS';
export const FAILURE = '@app/departmetns/settings/depatment-courses/get/FAILURE';

export const CLEAR = '@app/departmetns/settings/depatment-courses/data/CLEAR';

export const UPDATE_REQUEST = '@app/departmetns/settings/depatment-courses/put/REQUEST';
export const UPDATE_SUCCESS = '@app/departmetns/settings/depatment-courses/put/SUCCESS';
export const UPDATE_FAILURE = '@app/departmetns/settings/depatment-courses/put/FAILURE';

export const TOGGLE_REQUEST = '@app/departmetns/settings/depatment-courses/toggle/put/REQUEST';
export const TOGGLE_SUCCESS = '@app/departmetns/settings/depatment-courses/toggle/put/SUCCESS';
export const TOGGLE_FAILURE = '@app/departmetns/settings/depatment-courses/toggle/put/FAILURE';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    courses: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case REQUEST:
                draft.loading = true;
                draft.error = '';
                break;
            case SUCCESS:
            case UPDATE_SUCCESS:
                draft.loading = false;
                draft.courses = payload.map((pld) => ({
                    ...pld.course,
                    company_course_id: pld.id,
                    leadIcon: 'e-remove',
                    required: !!pld.enabled
                }));
                break;
            case TOGGLE_SUCCESS:
                draft.courses = draft.courses.map((pld) => {
                    if (payload.id === pld.company_course_id) {
                        return {
                            ...pld,
                            required: !!payload.enabled
                        };
                    }
                    return pld;
                });
                break;
            case FAILURE:
                draft.loading = false;
                draft.error = payload;
                break;
            case CLEAR:
                draft.error = '';
                draft.courses = [];
                draft.loading = false;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    update: (data) => creator(UPDATE_REQUEST, data),
    toggle: (data) => creator(TOGGLE_REQUEST, data),
    toggleSuccess: (data) => creator(TOGGLE_SUCCESS, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *get({ payload }) {
        try {
            const response = yield axios.get(`/companies/courses/${payload}`);
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    },

    *put({ payload }) {
        try {
            const response = yield axios.put(`/companies/courses/${payload.company_id}`, payload);
            yield put(actions.success(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    },

    *toggle({ payload }) {
        try {
            const response = yield axios.put(
                `/companies/courses/update-toggle/${payload.company_course_id}`
            );
            yield put(actions.toggleSuccess(response.data.data));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.get);
    yield takeLatest(UPDATE_REQUEST, sagas.put);
    yield takeLatest(TOGGLE_REQUEST, sagas.toggle);
};
